export const CATEGORY_TYPE_CUSTOM =
    'App\\Models\\Pattern\\CustomPatternCategory';
export const CATEGORY_TYPE_DEFAULT =
    'App\\Models\\Pattern\\DefaultPatternCategory';

export const CATEGORY_TYPE_SUBCATEGORY =
    'App\\Models\\Pattern\\PatternSubCategory';
